import { createMergeReducer } from '../utils/reducer'

type Features =
| 'useFaq'
| 'useContactUs'
| 'isElcano'
| 'useBtfTab'
| 'enableLeavingSoonBtf'
| 'enableSPAGiftCard'

export type FeatureToStatus = { [feature in Features]?: boolean } & AtfTreatmentProps & BtfTabTreatmentProps
export const reducer = createMergeReducer(
  t => t.features,
  {} as FeatureToStatus
)

export interface AtfTreatmentProps {
  atfTreatment?: AtfTreatment
}
export type AtfTreatment = 'C' | 'T1' | 'T2' | 'T3'

export interface BtfTabTreatmentProps {
  btfTabTreatment?: BtfTabTreatment
}
export type BtfTabTreatment = 'C' | 'T1' | 'T2' | 'T3'
